import { SignedDocument, SseEvents, SseResultObject } from '../states';
import { StateRequest } from './RequestReducer';

export const initialStateOperationStarted: StateRequest<
  SseResultObject[SseEvents.OPERATION_STARTED]
> = {
  loading: true,
  error: false,
};

export const initialStateIdCaptured: StateRequest<
  SseResultObject[SseEvents.ID_CAPTURED]
> = {
  loading: true,
  error: false,
};

export const initialStateSelfieCaptured: StateRequest<
  SseResultObject[SseEvents.SELFIE_CAPTURED]
> = {
  loading: true,
  error: false,
};

export const initialStateFacialAuthentication: StateRequest<
  SseResultObject[SseEvents.FACIAL_AUTHENTICATION_EVALUATED]
> = {
  loading: true,
  error: false,
};

export const initialStateFacialExtraction: StateRequest<
  SseResultObject[SseEvents.FACIAL_EXTRACTION_EVALUATED]
> = {
  loading: true,
  error: false,
};

export const initialStatePassiveLiveness: StateRequest<
  SseResultObject[SseEvents.PASSIVE_LIVENESS_EVALUATED]
> = {
  loading: true,
  error: false,
};

export const initialStateIdValiated: StateRequest<
  SseResultObject[SseEvents.ID_VALIDATED]
> = {
  loading: true,
  error: false,
};

export const initialStateCivilRegistry: StateRequest<
  SseResultObject[SseEvents.CIVIL_REGISTRY_VALIDATED]
> = {
  loading: true,
  error: false,
};

export const initialStatePreviousOnboarding: StateRequest<
  SseResultObject[SseEvents.PREVIOUS_ONBOARDING_VALIDATED]
> = {
  loading: true,
  error: false,
};

export const initialStateOperationFinished: StateRequest<
  SseResultObject[SseEvents.OPERATION_FINISHED]
> = {
  loading: true,
  error: false,
};

export const initialStateOperationExpired: StateRequest<
  SseResultObject[SseEvents.OPERATION_EXPIRED]
> = {
  loading: true,
  error: false,
};

export const initialStateDocumentSignature: StateRequest<SignedDocument> = {
  loading: false,
  error: false,
};

export const initialStatePersonalInformationGathered: StateRequest<
  SseResultObject[SseEvents.PERSONAL_INFORMATION_GATHERED]
> = {
  loading: true,
  error: false,
};
